if (!window.Eurus.loadedScript.has('pdp-comparison.js')) {
  window.Eurus.loadedScript.add('pdp-comparison.js');
  
  const init = () => {
    Alpine.store('xPdpComparisonPopup', {
      loadTablet(el) {
        const initYotpo = () => {
          el.querySelectorAll('.yotpo.bottomLine, .yotpo-widget-instance').forEach((yotpoElem) => {
            yotpoElem.removeAttribute('data-yotpo-element-loaded');
            // yotpoElem.innerHTML = '';
          });
          if (window.reinitYotpo) {
            window.reinitYotpo();
          }
        };

        el.querySelectorAll('.content-tablet').forEach((item) => {
          if (el.querySelector('.'+item.dataset.selectHtml)) {
            el.querySelector('.'+item.dataset.selectHtml).innerHTML += item.innerHTML;
          }
        });
        
        const buttonText = el.closest('[data-button-text]')?.getAttribute('data-button-text');
        if (buttonText) {
          el.querySelectorAll('.button-block .button').forEach((btn) => {
            const innerSpan = btn.querySelector('span');
            if (innerSpan) {
              innerSpan.textContent = buttonText;
            }
          });
        }
        initYotpo();
      }
    });

    Alpine.data('xPdpComparison', () => ({
      show: 1,
      openTabs: [],
      setOpenTab(tab) {
        if (this.openTabs.includes(tab)) {
          this.openTabs = this.openTabs.filter(t => t !== tab);
        } else {
          this.openTabs.push(tab);
        }
      },
      checkOpenTab(tab) {
        return this.openTabs.includes(tab);
      }
    }));
  };

  if (window.Alpine) {
    init();
  } else {
    document.addEventListener('alpine:init', init);
  }
}
